import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';
import i18n from 'locales/i18n';

type Props = {
  imageSrc: string;
  title: string;
  subtitle: string;
};

export const AuthPagesSliderItem: React.FC<Props> = ({ imageSrc, title, subtitle }) => {
  const direction = i18n.dir();

  const classes = useStyles({ direction });

  return (
    <Box
      flex={1}
      height='100%'
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='space-evenly'
      className={classes.slideContent}
    >
      <img src={imageSrc} alt={title} className={classes.slideImage} />

      <Box display='flex' flexDirection='column' alignItems='center' className={classes.textContainer}>
        <Typography variant='h3' align='center' className={classes.title}>
          {title}
        </Typography>
        <Typography variant='h4' align='center' className={classes.subtitle}>
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};